(function ($) {
	$(document).ready(function() {
		// Adds a class to image gallery figcaptions that styles the text inside to look like a link
		$('figcaption:has(> a)').addClass('image-gallery-link');

		var maxLength = 200;
		$(".show-read-more").each(function(){
			var myStr = $(this).text();
			if($.trim(myStr).length > maxLength){
				var newStr = myStr.substring(0, maxLength);
				var removedStr = myStr.substring(maxLength, $.trim(myStr).length);
				$(this).empty().html(newStr);
				$(this).append(' <a href="javascript:void(0);" class="read-more">read more</a>');
				$(this).append('<span class="more-text">' + removedStr + '</span>');
				}
			})
		
			$(".read-more").click(function(){
				$(this).siblings(".more-text").contents().unwrap();
				$(this).remove();
			});
		});

		$('.recommended-filter').change(function() {
	    var filterValue = $(this).val();
	    var row = $('.recommended-group'); 
	    //console.log('test');
	    row.hide()
	    row.each(function(i, el) {
	         if($(el).attr('data-type') == filterValue) {
	             $(el).show();
	         }
	    });
    });
}(jQuery));